export default __webpack_public_path__ + "static/media/third_slogan.eda9a6a7.png";